import { offsetDateForBrowser, offsetDateForServer } from "../../shared/timeZoneLogic";
import { formatPrice } from "../../shared/teamCurrencyFormatting";

export const DATE_AND_TIME = "Date & Time";
export const DATE_AND_TIME_ONLY = [{ value: DATE_AND_TIME, label: DATE_AND_TIME }];

export const STATUS_BADGES = {
  active: { label: "Active", color: "success" },
  scheduled: { label: "Scheduled", color: "blue" },
  ended: { label: "Ended", color: "gray" },
  used_up: { label: "Used up", color: "warning" },
};

export const blankClassPromoCode = (timeZone) => ({
  name: "",
  percentage: null,
  amount_two_decimals: null,
  unlimited: true,
  limit: null,
  availability: DATE_AND_TIME,
  applies_to_ticket_types: true,
  reveal_hidden_tickets: false,
  start_date_midday: offsetDateForBrowser(new Date(), timeZone),
  start_time_with_wrong_date: offsetDateForBrowser(new Date(), timeZone),
  end_date_midday: null,
  end_time_with_wrong_date: null,
});

export const classPromoCodeToForm = (promoCode, timeZone) => {
  const start = offsetDateForBrowser(promoCode.start_time, timeZone);
  const end = offsetDateForBrowser(promoCode.end_time, timeZone);
  return {
    id: promoCode.id,
    name: promoCode.name,
    percentage: promoCode.percentage,
    amount_two_decimals: promoCode.amount,
    unlimited: promoCode.unlimited,
    limit: promoCode.limit,
    availability: DATE_AND_TIME,
    applies_to_ticket_types: true,
    reveal_hidden_tickets: false,
    start_date_midday: new Date(start),
    start_time_with_wrong_date: new Date(start),
    end_date_midday: new Date(end),
    end_time_with_wrong_date: new Date(end),
  };
};

const wallClock = (date, time) => {
  const day = new Date(date);
  const clock = new Date(time);
  return new Date(day.getFullYear(), day.getMonth(), day.getDate(), clock.getHours(), clock.getMinutes());
};

const numberOrNull = (value) => {
  if (value === null || value === undefined || value === "") return null;
  return Number(String(value).replace(/[^0-9.]/g, ""));
};

export const classPromoCodePayload = (form, timeZone) => ({
  name: form.name,
  percentage: form.discount_mode === "amount" ? null : numberOrNull(form.percentage),
  amount: form.discount_mode === "amount" ? numberOrNull(form.amount_two_decimals) : null,
  unlimited: Boolean(form.unlimited),
  limit: form.unlimited ? null : numberOrNull(form.limit),
  start_time: offsetDateForServer(wallClock(form.start_date_midday, form.start_time_with_wrong_date), timeZone).toISOString(),
  end_time: offsetDateForServer(wallClock(form.end_date_midday, form.end_time_with_wrong_date), timeZone).toISOString(),
});

export const discountLabel = (promoCode, currencyCode) => (
  promoCode.amount ? `${formatPrice(Number(promoCode.amount), currencyCode)} off each spot` : `${promoCode.percentage}% off each spot`
);

export const usesLabel = (promoCode) => (
  promoCode.unlimited ? `${promoCode.number_claimed} used` : `${promoCode.number_claimed} of ${promoCode.limit} used`
);
